var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('h2',{staticClass:"c-title c-title--page"},[_vm._v(_vm._s(_vm.$t('display.add')))]),_c('display',{on:{"submit":function($event){return _vm.save($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }